var map = {
	"./de/warrior-name.png": "gUzS",
	"./en/warrior-name.png": "W7RA",
	"./es/warrior-name.png": "d582",
	"./fr/warrior-name.png": "YKSE",
	"./ja/warrior-name.png": "uOzs",
	"./ko/warrior-name.png": "SLL+",
	"./pt/warrior-name.png": "maCa",
	"./ru/warrior-name.png": "Wo++",
	"./th/warrior-name.png": "vjfF",
	"./zh-Hant/warrior-name.png": "bttS"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "YHac";